import { useOpenCommandMenu } from '@/command-menu/hooks/useOpenCommandMenu';
import { useGlobalHotkeys } from '@/ui/utilities/hotkey/hooks/useGlobalHotkeys';

export const CommandMenuHotkeyEffect = () => {
  const { openCommandMenu } = useOpenCommandMenu();

  useGlobalHotkeys({
    keys: 'mod+k',
    callback: openCommandMenu,
    // A modifier combination can't be typed by accident, so it also works
    // from inside a text field.
    enableOnFormTags: true,
  });

  return null;
};
